module.exports = __webpack_public_path__ + "img/header-weddingRingsClassic@2x.0e2a996.webp";